import { Component, OnInit } from '@angular/core';
import { ClientesService } from '../../../services/Clientes.service';
import { RutasService } from '../../../services/rutas.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../../helpers/helper';
import { LowerCasePipe, DatePipe } from '@angular/common';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
import { AlertasModales } from '../../../helpers/alertasModales';
import { RegionesService } from '../../../services/regiones.service';

const ID_PAGINA = 3;


@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styles: [
    `
    table {
      font-size: 14px
    }
    `
  ]
})
export class ListaClientesComponent implements OnInit {
  private columnsServer = [];
  listaClientes: any = [];
  page = 1;
  limit = '50';
  offset = 0;
  size = 0;
  sucursal: any = String(this.helper.compania);
  loaded = false;
  loading = false;
  rutas = [];
  regiones = [];
  subregiones = [];
  regionSeleccionada = [];
  subRegionSeleccionada = [];
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  nc = '';
  active: number;
  exportando = false;
  configPdf: any;
  columnsSort = [];
  multiSelectPrestamos: any;
  multiSelectRegiones: any;
  multiSelectSubRegiones: any;
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  puedeRenovar = 'todos';
  fallecidos = 'todos';
  timeout: any;

  constructor(
    public _clientes: ClientesService,
    public empleadoService: EmpleadosServicio,
    private rutaService: RutasService,
    private route: ActivatedRoute,
    private router: Router,
    private configuracionService: ConfiguracionesService,
    public helper: Helper,
    private regionesService: RegionesService,
    private modals: AlertasModales
  ) {
    if (
      empleadoService.datosEmpleado.tipo_empleado !== 3 &&
      !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }

    this.initRuta(); this.initRegiones();
    /*if (localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }*/
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    console.log(this.rutasSeleccionadas);
    if  (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }

    this.initColumns();
    this.initConfigPdf();
  }

  ngOnInit() {
    this.verificarQueryString();
    this.initConfigMultiSelect();
  }

  private initRuta(): void {
    this.rutaService.cargarTodasLasRutas()
      .subscribe(rutas => {
        for (const ruta of rutas.rutas) {
          this.rutas.push({
            id: ruta.ID_RUTA,
            itemName: String(ruta.nombre)
          });
        }
      });
  }

  private initConfigMultiSelect() {
    this.multiSelectPrestamos = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda'
    };

    this.multiSelectRegiones = {
      singleSelection: false,
      text: 'Seleccionar Region',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 4,
      searchPlaceholderText: 'Búsqueda'
    };

    this.multiSelectSubRegiones = {
      singleSelection: false,
      text: 'Seleccionar Sub-Region',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 4,
      searchPlaceholderText: 'Búsqueda'
    };

  }

  private initRegiones(): void {
    this.regionesService.regiones().subscribe(RESPONSE => {

      for (const region of RESPONSE) {
        this.regiones.push({
          id: region.ID_REGION,
          itemName: String(region.nombre)
        })
      }
    });
  }

  initSubregiones(): void {
    this.subregiones = [];
    this.regionesService.subRegiones(this.regionSeleccionada.map(data => data.id).join()).subscribe(RESPONSE => {
      console.log(this.regionSeleccionada)
      for (const region of RESPONSE) {
        this.subregiones.push({
          id: region.ID_SUBREGION,
          itemName: String(region.nombre)
        })
      }
    });
  }

  private cargarListaClientes(): void {
    this.loading = true;
    let fecha_desde = '';
    let fecha_hasta = '';
    if (this.fecha_desde) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    this._clientes.obtenerClientes(
      this.limit,
      this.offset,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.nc,
      fecha_desde,
      fecha_hasta,
      this.sucursal,
      JSON.stringify(this.columnsServer),
      this.regionSeleccionada.map(data => data.id).join(),
      this.subRegionSeleccionada.map(data => data.id).join(),
      this.puedeRenovar,
      this.fallecidos)
      .subscribe((result: any) => {
        this.active = parseFloat(localStorage.getItem('cliente_active')) || -1;

        this.listaClientes = result.clientes;
        this.size = result.total_items;
        setTimeout(() => { this.loaded = true; this.loading = false; }, 1);
      });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.sucursal === 'actual' || params.sucursal !== 'todas') {
          this.sucursal = this.helper.compania;
        } else {
          this.sucursal = '-1';
        }
        if (params.nc) {
          this.nc = params.nc;
        }
        /* if (params.region) {
          this.regionSeleccionada = params.region;
          this.initSubregiones();
        }
        if (params.subregion) {
          this.subRegionSeleccionada = params.subregion;
        } */
        if (params.limite) {
          this.limit = params.limite;
        }
        if (params.puede_renovar) {
          this.puedeRenovar = params.puede_renovar;
        }
        if (params.fallecidos) {
          this.fallecidos = params.fallecidos;
        }
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = parseFloat(this.limit) * (this.page - 1);
        }
        if (params.fecha_inicia || params.fecha_termina) {

          if (params.fecha_inicia) {
            const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
            const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
            const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

            if (!isNaN(yearInit) && !isNaN(monthInit) && !isNaN(dayInit)) {
              this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            }
          }

          if (params.fecha_termina) {
            const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
            const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
            const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

            if (!isNaN(yearEnd) && !isNaN(monthEnd) && !isNaN(dayEnd)) {
              this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
            }
          }
        }
        if (params.rutas && !this.rutasSeleccionadasAntes) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }

          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }

        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }


        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }
        this.cargarListaClientes();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.offset = parseFloat(this.limit) * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/clientes'], { queryParams: queryParams });
    this.cargarListaClientes();
  }

  filtrarClientes() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['nc'] = this.nc;
    queryParams['region'] = this.regionSeleccionada;
    queryParams['subregion'] = this.subRegionSeleccionada;
    queryParams['limite'] = this.limit;

    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    } else {
      delete queryParams['rutas'];
    }
    if (this.puedeRenovar) {
      queryParams['puede_renovar'] = this.puedeRenovar;
    }
    if (this.fallecidos) {
      queryParams['fallecidos'] = this.fallecidos;
    }
    if (this.sucursal !== '-1') {
      queryParams['sucursal'] = 'actual';
    } else {
      queryParams['sucursal'] = 'todas';
    }
    if (
      this.fecha_desde !== undefined &&
      this.fecha_desde !== null &&
      this.fecha_desde.year !== null
    ) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (
      this.fecha_hasta !== undefined &&
      this.fecha_hasta !== null &&
      this.fecha_hasta.year !== null
    ) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    const regions = this.regionSeleccionada.map(data => data.id).join()

    if (regions) {
      queryParams['region'] = regions;

      this.initSubregiones();
    }
    else {
      if (this.regionSeleccionada.length >= 1) {
        this.initSubregiones()
      }
      else {
        this.subregiones = []
        this.subRegionSeleccionada = []
      }
      delete queryParams['region'];
    }
    const subRegion = this.subRegionSeleccionada.map(data => data.id).join()
    if (subRegion) {
      queryParams['subregion'] = subRegion;
    }
    else {
      delete queryParams['subregion'];
    }

    this.router.navigate(['./lista/clientes'], { queryParams: queryParams });
  }

  navigate(cliente) {
    localStorage.setItem('cliente_active', cliente.ID_C);
    this.router.navigate(['/cliente', cliente.ID_C]);
  }

  exportar(downOpen = true) {
    if (this.empleadoService.permisosAsignados.filter(a => a.ID_PERMISO == 1).length || this.empleadoService.datosEmpleado.tipo_empleado === 3) {
      if (!this.exportando && this.listaClientes.length > 0) {
        this.exportando = true;
        const rows = [];
        const lowerCasePipe = new LowerCasePipe();
        const datePipe = new DatePipe('en-US');
        const columns = [
          { title: 'No.', dataKey: 0 },
          { title: 'Cliente', dataKey: 1 },
          { title: 'Identificación', dataKey: 2 },
          { title: 'Teléfono', dataKey: 3 },
          { title: 'Zona', dataKey: 4 },
          { title: 'Direccón', dataKey: 5 },
          { title: 'Región', dataKey: 6 },
          { title: 'Fecha registro', dataKey: 6 }
        ];

        let fecha_desde = '';
        let fecha_hasta = '';
        if (this.fecha_desde) {
          fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
        }

        if (this.fecha_hasta) {
          fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
        }
        this._clientes.obtenerClientes(
          0, 0,
          this.rutasSeleccionadas.map(data => data.id).join(),
          this.nc,
          fecha_desde,
          fecha_hasta,
          this.sucursal,
          JSON.stringify(this.columnsServer))
          .subscribe((res: any) => {

            for (const row of res.clientes) {
              rows.push({
                0: row.id,
                1: this.helper.capitalizeFirstLetter(lowerCasePipe.transform(row.nombre + ' ' + row.apellido)),
                2: row.cedula,
                3: row.telefono,
                4: row.ruta_nombre,
                5: row.direccion,
                6: row.region,
                7: datePipe.transform(row.fecha_registro, 'dd-MM-yyyy')
              });
            }

            const columnStyles = {
              id: { fillColor: 255, textColor: 0 },
              0: { columnWidth: 60 },
              2: { columnWidth: 80 },
              3: { columnWidth: 80 },
              6: { columnWidth: 80 },
            };

            this.helper.exportarReportePdf(this.configPdf,
              'Lista de Clientes',
              columns,
              rows,
              this.empleadoService.datosEmpleado.usuario,
              columnStyles,
              'l',
              downOpen)
              .then(() => {
                this.exportando = false;
              })
              .catch(() => {
                this.exportando = false;
              });
          });
      }
    } else {
      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
        'red',
        'modern',
        false,
        'fa fa-thumbs-down');
    }
  }

  private initConfigPdf(): void {
    this.configuracionService.obtenerConfiguraciones()
      .subscribe((res: any) => {
        this.configPdf = {
          direccion: res.direccion_recibo,
          tel: res.telefono_recibo,
          nombre_compania: res.descripcion,
          rnc_compania: res.rnc,
          fax_compania: res.fax,
          email_compania: res.email,
          ciudad_compania: res.ciudad,
          tel_compania: res.telefono,
          direccion_compania: res.dirección
        };
      });
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./lista/clientes'], { queryParams: queryParams });
  }

  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'No',
        column: `id`,
        order: ''
      },
      {
        label: 'Cliente',
        column: `CONCAT(c.nombre, ' ', c.apellido)`,
        order: ''
      },
      {
        label: 'Cédula',
        column: 'c.cedula',
        order: ''
      },
      {
        label: 'Teléfono',
        column: 'c.telefono',
        order: ''
      },
      {
        label: 'Zona',
        column: 'c.ID_RUTA',
        order: ''
      },
      {
        label: 'Región',
        column: 'c.region',
        order: ''
      },
      {
        label: 'Dirección',
        column: 'c.direccion',
        order: ''
      },
      {
        label: 'Fecha',
        column: 'c.fecha_registro',
        order: ''
      },
    ];
  }

  onBusqueda() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.filtrarClientes(), 700);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/clientes/lista/lista.component.ts